import { createApp } from "vue";
import ArticleIndex from "./ArticleIndex.vue";

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector("#articleIndex")) {
    return
  }

  const articleIndex = createApp({
    components: { ArticleIndex }
  })

  articleIndex.mount("#articleIndex")
})
